import Stomp from 'stompjs';
import SockJS from 'sockjs-client';
import axios from 'axios';

class MonitorWSService {

    constructor() {
        let hostName = window.location.hostname
        this.server = "/monitorservice/";//TRAMPA,

        //! TODO: Trampa
        if (hostName === 'localhost' || hostName === '127.0.0.1' || hostName === "dev.andrei.io")
            this.server = "http://devomni.andrei.io:8090/monitorservice/";//TRAMPA,

        this.stompClient = null;
    }

    async connect(token, callBack) {

        let authorized = true;

        try {
            const config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${this.server}api/checktoken`,
                headers: {
                    'Authorization': token
                }
            };

            const res = await axios.request(config);
            authorized = res.data;
        } catch (e) {
            console.error('checktoken: error' + e);
        }

        if (!authorized) {            
            console.debug('Connected: unauthorized');
            const event = new Event('wsConnectionUnauthorized');
            document.dispatchEvent(event);
            callBack(false);
        } else {
            const socket = new SockJS(`${this.server}monitorweb?token=${token}`);
            this.stompClient = Stomp.over(socket);
            this.stompClient.heartbeat.outgoing = 20000;
            this.stompClient.heartbeat.incoming = 0;
            this.stompClient.reconnect_delay = 5000;
            this.stompClient.debug = null;
            this.stompClient.connect({}, (frame) => {
                console.debug('Connected: ' + frame);
                callBack(true);
            }, (error) => {
                console.error('Connection error: ' + error);
                const event = new Event('wsConnectionLost');
                document.dispatchEvent(event);
                callBack(false);
            });
        }
    }

}

const monitorWSService = new MonitorWSService();
export default monitorWSService;